import { Component } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-stats-modal',
  templateUrl: './add-stats-modal.component.html',
  styleUrls: ['./add-stats-modal.component.less']
})
export class AddStatsModalComponent {
  closeResult: string;
  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal) { }

  open(content) {
    this.modalRef = this.modalService.open(content,  { backdropClass : 'backdropClassModal'});
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/add-stats-modal/add-stats-modal.component.ts